import moment from "moment-timezone";
import "moment/locale/ru";
// import "moment/locale/en";
import "moment/locale/et";
import "moment/locale/es";
import i18n from "../i18n";

moment.tz.setDefault("Europe/Tallinn");

moment.updateLocale("ru", {
    week: { dow: 1 },
});
moment.updateLocale("en", {
    week: { dow: 1 },
});
moment.updateLocale("et", {
    week: { dow: 1 },
});
moment.updateLocale("es", {
    week: { dow: 1 },
});

export const setMomentLocale = (lng: string) => {
    moment.locale(lng);
};

export default moment;

export const isTimeinRange = (startTime: string, endTime: string): boolean => {
    if (!startTime || !endTime) {
        return false;
    }
    const currentDate = moment();
    const currentDateTime = moment(currentDate.format("YYYY-MM-DD HH:mm"));
    const startDateTime = moment(`${currentDate.format("YYYY-MM-DD")} ${startTime}`, "YYYY-MM-DD HH:mm");
    const endDateTime = moment(`${currentDate.format("YYYY-MM-DD")} ${endTime}`, "YYYY-MM-DD HH:mm");

    return currentDateTime.isBefore(endDateTime) && currentDateTime.isSameOrAfter(startDateTime);
};

export const isTimeBefore = (time: string): boolean => {
    if (!time) {
        return false;
    }
    const currentDate = moment();
    const currentDateTime = moment(currentDate.format("YYYY-MM-DD HH:mm"));
    const dateTime = moment(`${currentDate.format("YYYY-MM-DD")} ${time}`, "YYYY-MM-DD HH:mm");

    return currentDateTime.isBefore(dateTime);
};

export const isValidDateFormat = (value: string, format: string): boolean => {
    return moment(value, format, true).isValid();
};

export const getDuelDate = (date: string, time: string, format: string): string => {
    const localDate = moment(date)
        ?.hour(time ? +time : 0)
        ?.format(format);
    return localDate;
};

// compare two times in format like "10:00"
export const compareTime = (time1: string, time2: string) => {
    const [hours1, minutes1] = time1.split(":");
    const [hours2, minutes2] = time2.split(":");
    const totalMinutes1 = parseInt(hours1) * 60 + parseInt(minutes1);
    const totalMinutes2 = parseInt(hours2) * 60 + parseInt(minutes2);
    if (totalMinutes1 < totalMinutes2) {
        return -1;
    } else if (totalMinutes1 > totalMinutes2) {
        return 1;
    } else {
        return 0;
    }
};

export const formatSeconds = (seconds: number): string => {
    const minutes = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    const millis = Math.round((seconds % 1) * 100);
    const formattedMinutes = String(minutes).padStart(2, "0");
    const formattedSeconds = String(secs).padStart(2, "0");
    const formattedMillis = String(millis).padStart(2, "0");
    return `${formattedMinutes}:${formattedSeconds}:${formattedMillis}`;
};

export const getCurrentYear = () => moment().year();

export const getUserTimezone = (): { timezone: string; diff: string } => {
    const userTz = moment.tz.guess();

    const tallinnOffset = moment().tz("Europe/Tallinn").utcOffset();
    const userOffset = moment().tz(userTz).utcOffset();

    const diffHours = (userOffset - tallinnOffset) / 60;

    const sign = diffHours > 0 ? "+" : "";

    const absHours = Math.abs(diffHours);
    const hourWord = getHourWord(absHours);

    return {
        timezone: userTz,
        diff: `${sign}${diffHours} ${hourWord}`,
    };
};

const getHourWord = (h: number) => {
    return i18n.t("common.units.hour", { count: Math.abs(h) });
};
